module.exports = __webpack_public_path__ + "assets/7f58ffa0cd3d731f53a70bb433871085.png";